module.exports = __webpack_public_path__ + "img/idea-vision-challenge-icon.d754bb52.svg";